// src/api/memory.ts
//
// Typed client for the memory service.

import { getMemoryServiceUrl } from '../utils/backend'
import { createApiClient } from './base'

const memoryClient = createApiClient(getMemoryServiceUrl)

// ---------------------------------------------------------------------------
// Types
// ---------------------------------------------------------------------------

export type Memory = {
  id?: string
  content: string
  [key: string]: unknown
}

export type CoreMemoryResponse = {
  user_id?: string
  memories?: Memory[]
  [key: string]: unknown
}

// ---------------------------------------------------------------------------
// Core memory
// ---------------------------------------------------------------------------

export async function getCoreMemory(
  userId: string,
  signal?: AbortSignal,
): Promise<CoreMemoryResponse> {
  return memoryClient.request<CoreMemoryResponse>(
    `/core-memory/?user_id=${encodeURIComponent(userId)}`,
    { signal },
  )
}

export async function updateCoreMemory(
  userId: string,
  coreMemory: CoreMemoryResponse,
): Promise<void> {
  await memoryClient.request('/core-memory/update/', {
    method: 'POST',
    body: { user_id: userId, core_memory: coreMemory },
  })
}
